import React from 'react';
import { Chip, Stack, Tooltip } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

/** Mirrors folio-debtor-management admin statusTone() for notification statuses. */
const STATUS_CHIP_SX = {
	scheduled: {
		backgroundColor: 'rgba(245, 158, 11, 0.16)',
		color: '#765000',
	},
	queued: {
		backgroundColor: 'rgba(245, 158, 11, 0.16)',
		color: '#765000',
	},
	sent: {
		backgroundColor: 'rgba(15, 118, 110, 0.14)',
		color: '#0b624f',
	},
	failed: {
		backgroundColor: 'rgba(220, 38, 38, 0.12)',
		color: '#b91c1c',
	},
	cancelled: {
		backgroundColor: 'rgba(220, 38, 38, 0.12)',
		color: '#b91c1c',
	},
	skipped: {
		backgroundColor: 'rgba(100, 116, 139, 0.14)',
		color: '#64748b',
	},
};

/**
 * Status chip matching folio-debtor-management Scheduled Notifications badges.
 * @param {{ status?: string, errorMessage?: string | null }} props
 */
export const ReminderStatusChip = ({ status, errorMessage }) => {
	const normalized = String(status ?? '').toLowerCase();
	const sx = STATUS_CHIP_SX[normalized] ?? STATUS_CHIP_SX.skipped;
	//Error messages come back with underscores...
	const tooltip = String(errorMessage ?? '')
		.trim()
		.replaceAll('_', ' ');
	// Only display error if there is a tooltip and the status is not sent.
	const displayError = Boolean(tooltip) && normalized !== 'sent';

	return (
		<Stack direction='row' spacing={0.75} alignItems='center'>
			<Chip
				size='small'
				label={status ?? '-'}
				sx={{
					...sx,
					textTransform: 'capitalize',
				}}
			/>
			{displayError && (
				<Tooltip title={tooltip} placement='top'>
					<ErrorOutlineIcon
						fontSize='small'
						color='error'
						aria-label={tooltip}
						sx={{ cursor: 'default' }}
					/>
				</Tooltip>
			)}
		</Stack>
	);
};

export default ReminderStatusChip;
